export const LABELS = {
  fecha_diligenciamiento: "Fecha de diligenciamiento", ciudad_diligenciamiento: "Ciudad",
  nombres: "Nombres", primer_apellido: "Primer apellido", segundo_apellido: "Segundo apellido",
  tipo_documento: "Tipo de documento", numero_documento: "Número de documento",
  lugar_nacimiento: "Lugar de nacimiento", fecha_nacimiento: "Fecha de nacimiento", estado_civil: "Estado civil",
  profesion_oficio: "Profesión u oficio", tarjeta_profesional: "Tarjeta profesional No.",
  direccion_residencia: "Dirección de residencia", barrio: "Barrio", ciudad_residencia: "Ciudad de residencia",
  celular: "Celular", correo_electronico: "Correo electrónico", ultimo_nivel_estudios: "Último nivel de estudios",
  eps: "EPS", fondo_pensiones: "Fondo de pensiones", fondo_cesantias: "Fondo de cesantías",
  fecha_expedicion: "Fecha de expedición del documento", lugar_expedicion: "Lugar de expedición del documento",
  grupo_sanguineo: "Grupo sanguíneo (RH)", libreta_militar: "Libreta militar No.", telefono_fijo: "Teléfono fijo / otro contacto",
  departamento_expedicion: "Departamento de expedición", departamento_residencia: "Departamento de residencia",
  arl: "ARL", caja_compensacion: "Caja de compensación", entidad_bancaria: "Entidad bancaria",
  tipo_cuenta: "Tipo de cuenta", numero_cuenta: "Número de cuenta",
  accidente_laboral: "¿Ha tenido accidente laboral?", accidente_detalle: "Detalle del accidente",
  perdida_capacidad: "Pérdida de capacidad laboral (%)",
  antecedente_medico: "¿Antecedente médico de importancia?", antecedente_detalle: "Detalle del antecedente",
  perfil_ocupacional: "Perfil ocupacional", habilidades_persona: "Descripción de habilidades como persona",
  medio_oferta: "¿Por qué medio se enteró de la oferta?",
  nombre: "Nombre", identificacion: "Identificación", parentesco: "Parentesco", telefono: "Teléfono",
  nombre_empresa: "Nombre de la empresa", direccion: "Dirección", actividad_comercial: "Actividad comercial",
  fecha_ingreso: "Fecha de ingreso", motivo_retiro: "Motivo de retiro", cargo: "Cargo desempeñado",
  salario: "Salario", jefe_directo: "Jefe directo", telefono_jefe: "Teléfono jefe directo", funciones: "Funciones",
  estudios_realizados: "Estudios realizados", anio_finalizacion: "Año de finalización", titulo_obtenido: "Título obtenido",
};

export const SECTION_LABELS = {
  datos_personales: "Datos personales", salud: "Salud", perfil: "Perfil ocupacional",
  familia: "Conformación familiar", contactos_emergencia: "Contactos de emergencia",
  referencias_laborales: "Referencias laborales", referencias_familiares: "Referencias personales familiares",
  referencias_no_familiares: "Referencias personales no familiares", academica: "Información académica",
};

export const lbl = (k) => LABELS[k] || k.replace(/_/g, " ");

export const DOC_ESTADO = {
  recibido: { label: "Recibido", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  confirmado_empleado: { label: "Confirmado por el empleado", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  validado_human: { label: "Validado por HUMAN", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  correccion_requerida: { label: "Corrección requerida", cls: "bg-red-50 text-red-700 border-red-200" },
  pendiente_revision: { label: "Pendiente de revisión", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export const EXP_ESTADO = {
  borrador: { label: "Borrador", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  enviado: { label: "Enviado a HUMAN", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  validado: { label: "Validado por HUMAN", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};
